function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".yourA{fill:none;stroke:#2ed573;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2528.698 -7154.194)"
}, /*#__PURE__*/React.createElement("path", {
  className: "yourA",
  d: "M678.822,47.8a10.042,10.042,0,1,0-9.884-10.041A9.964,9.964,0,0,0,678.822,47.8Z",
  transform: "translate(1878.882 7140.867)"
}), /*#__PURE__*/React.createElement("path", {
  className: "yourA",
  d: "M682.2,32.285l-6.589,6.694-3.295-3.347",
  transform: "translate(1880.448 7142.99)"
}), /*#__PURE__*/React.createElement("path", {
  className: "yourA",
  d: "M671.389,42H659.034a2.554,2.554,0,0,1-2.472-2.51V21.082a2.554,2.554,0,0,1,2.472-2.51h29.652a2.554,2.554,0,0,1,2.472,2.51v7.531",
  transform: "translate(1873.136 7136.623)"
}), /*#__PURE__*/React.createElement("path", {
  className: "yourA",
  d: "M690.123,19.2,673.65,32.583,657.013,19.028",
  transform: "translate(1873.345 7136.834)"
}));

function SvgYourOwn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.89,
    height: 35.469,
    viewBox: "0 0 39.89 35.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourOwn);
export default __webpack_public_path__ + "static/media/YourOwn.e4bc2555.svg";
export { ForwardRef as ReactComponent };